class Entry {
  constructor(id, date, amount, title, category) {
    this.id = id;
    this.date = date;
    this.amount = amount;
    this.title = title;
    this.category = category;
  }
}

export default Entry;
